/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: mojmir.studenovsky@eurowag.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UnitCodeLength,
    UnitCodeLengthFromJSON,
    UnitCodeLengthFromJSONTyped,
    UnitCodeLengthToJSON,
} from './';

/**
 * 
 * @export
 * @interface Length
 */
export interface Length {
    /**
     * 
     * @type {number}
     * @memberof Length
     */
    value: number;
    /**
     * 
     * @type {UnitCodeLength}
     * @memberof Length
     */
    unit: UnitCodeLength;
}

export function LengthFromJSON(json: any): Length {
    return LengthFromJSONTyped(json, false);
}

export function LengthFromJSONTyped(json: any, ignoreDiscriminator: boolean): Length {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'unit': UnitCodeLengthFromJSON(json['unit']),
    };
}

export function LengthToJSON(value?: Length | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'unit': UnitCodeLengthToJSON(value.unit),
    };
}


